<template>
	<div
		v-if="loaded"
		class="sal-components-stock-quote-bottom"
	>
		<sal-components-eqsv-sustainability
			class="sal-components-eqsv-sustainability__wrapper sal-component"
			hide-chiclet
			mwc-id="salEqsvSustainability"
		/>
	</div>
</template>

<script>
import SalComponentsEqsvSustainability from '@sal/eqsv-sustainability';
import SalCommonMixin from '@/mixins/sal-common';

export default {
	name: 'quote-bottom',
	components: {
		SalComponentsEqsvSustainability
	},
	mixins: [SalCommonMixin]
};
</script>
